<template>
  <h1>Your message has been submitted!</h1>
</template>

<script>
export default {};
</script>

<style></style>
